import React, { useEffect } from "react";
import { getStudioAuthUrl } from "../utilities/studio-auth";

/*
 * This is a legacy component that we've repurposed to handle the auth flow using studio app and auth0.
 * It will redirect the user to the studio auth url, which will handle the auth flow and then redirect
 * back to the app with a valid session for us to retrieve.
 */
function AuthIFrame(props) {
  useEffect(() => {
    window.location.replace(getStudioAuthUrl(props.path));
  }, [props.path]);

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{ marginTop: "-3.5rem" }}
    >
      <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
        {/* Maring left due to the image containing a load of spacing to the right */}
        <img
          src="/images/dragonflyai-logo.svg"
          height="42"
          alt="Dragonfly"
          style={{ marginLeft: "153px" }}
        />
        <p className="lead mt-2">Please wait...</p>
      </div>
    </div>
  );
}

export default AuthIFrame;
